/**
 * Shuttle Step 2 JavaScript
 * 
 * Handles route selection and display for shuttle booking step 2
 * 
 * @package A2A_Theme
 */

jQuery(document).ready(function($) {
    'use strict';
    
    /**
     * Step 2 Handler
     */
    class ShuttleStep2Handler {
        constructor() {
            this.manager = window.shuttleBookingManager;
            this.availableRoutes = []; // Current routes being displayed
            this.isInitialized = false;
            
            // DOM elements
            this.elements = {
                backBtn: $('#shuttle-back-btn'),
                title: $('#shuttle-step-2-title'),
                titleContainer: $('.shuttle-step-2__title'),
                routesContainer: $('#shuttle-step-2-routes'),
                progressSteps: $('.shuttle-progress__step')
            };
            
            // Load translatable strings from DOM (Weglot-compatible)
            this.loadTranslatableStrings();
            
            this.init();
        }
        
        /**
         * Load translatable strings from hidden DOM elements
         * This allows Weglot to translate them while keeping JavaScript dynamic
         */
        loadTranslatableStrings() {
            const container = document.getElementById('shuttle-translatable-strings');
            if (!container) {
                console.warn('Translatable strings container not found');
                this.titleTemplates = {};
                return;
            }
            
            this.titleTemplates = {};
            const spans = container.querySelectorAll('span[data-key]');
            spans.forEach(span => {
                const key = span.getAttribute('data-key');
                const text = span.textContent;
                this.titleTemplates[key] = text;
            });
        }
        
        /**
         * Initialize step 2 handler
         */
        async init() {
            if (this.isInitialized) return;
            
            try {
                
                // Add body class for styling
                $('body').addClass('shuttle-booking-page shuttle-booking-step-2');
                
                // Wait for booking manager to be ready
                await this.waitForManager();
                
                // Validate that we have booking data from step 1
                if (!this.validateBookingData()) {
                    this.redirectToLandingPage();
                    return;
                }
                
                // Validate existing route selections before proceeding
                if (!this.manager.validateRouteSelections()) {
                    // Reset invalid selections
                    this.manager.resetRouteSelections();
                }
                
                // Header is now populated by form component
                
                // Update progress breadcrumbs
                this.updateProgress();
                
                // Set up event listeners
                this.setupEventListeners();
                
                // Set up window resize handler for mobile navigation centering
                this.setupResizeHandler();
                
                // Load and display routes
                await this.loadAvailableRoutes();
                
                this.isInitialized = true;
                
            } catch (error) {
                console.error('Failed to initialize Shuttle Step 2:', error);
                this.showError('Failed to initialize route selection. Please try again.');
            }
        }
        
        /**
         * Wait for booking manager to be ready
         */
        async waitForManager() {
            let attempts = 0;
            const maxAttempts = 50;
            
            while (!window.shuttleBookingManager && attempts < maxAttempts) {
                await new Promise(resolve => setTimeout(resolve, 100));
                attempts++;
            }
            
            this.manager = window.shuttleBookingManager;
            
            if (!this.manager) {
                throw new Error('Booking manager not available');
            }
            
            // Wait for manager initialization to complete (loading destinations)
            if (this.manager.readyPromise) {
                await this.manager.readyPromise;
            }
        }
        
        /**
         * Validate that we have required booking data from step 1
         */
        validateBookingData() {
            const data = this.manager.bookingData;
            
            // Check if we have from/to locations
            if (!data.from || !data.from.id || !data.to || !data.to.id) {
                return false;
            }
            
            // Check if we have dates
            if (!data.outboundDate || !data.outboundTime) {
                return false;
            }
            
            // Check if we have passengers
            if (!data.passengers || (!data.passengers.adults && !data.passengers.children)) {
                return false;
            }
            
            // Guard against stale dates on disallowed weekdays (availability may
            // have changed since these dates were stored in a previous session)
            const allowedWeekdays = this.manager.getAllowedWeekdays();
            if (data.outboundDate && !allowedWeekdays.includes(this.manager.getDayOfWeekFromDate(data.outboundDate))) {
                return false;
            }
            if (data.transferType === 'return' && data.returnDate && !allowedWeekdays.includes(this.manager.getDayOfWeekFromDate(data.returnDate))) {
                return false;
            }
            
            return true;
        }
        
        /**
         * Redirect to landing page when no booking data exists
         */
        redirectToLandingPage() {
            const landingPageUrl = window.shuttleLandingPageUrl || '/';
            window.location.href = landingPageUrl;
        }
        
        
        /**
         * Update progress breadcrumbs
         */
        updateProgress() {
            const bookingData = this.manager.bookingData;
            
            // Show/hide return step based on transfer type
            if (bookingData.transferType === 'return') {
                $('.shuttle-progress__step--return').css('display', 'flex');
            } else {
                $('.shuttle-progress__step--return').css('display', 'none');
            }
            
            // Update active step based on current selection
            this.elements.progressSteps.removeClass('shuttle-progress__step--active shuttle-progress__step--completed');
            
            if (bookingData.currentSelection === 'return') {
                // Return selection active
                $('.shuttle-progress__step[data-step="outbound"]').addClass('shuttle-progress__step--completed');
                $('.shuttle-progress__step[data-step="return"]').addClass('shuttle-progress__step--active');
                
                // Center navigation on mobile when return step is active
                this.centerNavigationOnMobile(true);
            } else {
                // Outbound selection active (default)
                $('.shuttle-progress__step[data-step="outbound"]').addClass('shuttle-progress__step--active');
                
                // Reset navigation position on mobile
                this.centerNavigationOnMobile(false);
            }
        }
        
        /**
         * Center navigation on mobile screens (≤520px)
         */
        centerNavigationOnMobile(centerReturn = false) {
            // Only apply on mobile screens
            if (window.innerWidth > 520) {
                return;
            }
            
            const progressSteps = $('.shuttle-progress__steps');
            const returnStep = $('.shuttle-progress__step[data-step="return"]');
            
            if (centerReturn && returnStep.length > 0) {
                // Calculate the exact position to center the return step
                const container = $('.shuttle-progress__container');
                const containerWidth = container.width();
                const returnStepOffset = returnStep.position().left;
                const returnStepWidth = returnStep.outerWidth();
                
                // Calculate the transform needed to center the return step
                const centerPosition = containerWidth / 2;
                const returnStepCenter = returnStepOffset + (returnStepWidth / 2);
                const translateX = centerPosition - returnStepCenter;
                
                // Apply the calculated transform
                progressSteps.css('transform', `translateX(${translateX}px)`);
                progressSteps.addClass('shuttle-progress__steps--center-return');
            } else {
                // Reset to default position
                progressSteps.css('transform', 'translateX(0)');
                progressSteps.removeClass('shuttle-progress__steps--center-return');
            }
        }
        
        /**
         * Scroll to top of page on mobile screens
         */
        scrollToTopOnMobile() {
            // Only scroll on mobile/tablet screens (≤1024px)
            if (window.innerWidth <= 1024) {
                // Smooth scroll to top
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
        
        /**
         * Set up window resize handler for mobile navigation centering
         */
        setupResizeHandler() {
            let resizeTimeout;
            $(window).on('resize', () => {
                // Debounce resize events
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    // Recalculate navigation centering if return step is active
                    const bookingData = this.manager.bookingData;
                    if (bookingData.currentSelection === 'return') {
                        this.centerNavigationOnMobile(true);
                    }
                }, 150);
            });
        }
        
        /**
         * Set up event listeners
         */
        setupEventListeners() {
            // Back button - navigate to referrer page
            this.elements.backBtn.on('click', () => {
                this.manager.navigateBack();
            });
        }
        
        /**
         * Load and display available routes
         */
        async loadAvailableRoutes() {
            try {
                const bookingData = this.manager.bookingData;
                
                // Validate required data
                if (!bookingData.from?.id || !bookingData.to?.id || !bookingData.outboundDate) {
                    throw new Error('Missing required booking data for route loading');
                }
                
                // Determine current selection type to load correct routes
                const currentSelectionType = this.getCurrentSelectionType();
                
                // If we're selecting return routes, use the loadReturnRoutes method
                if (currentSelectionType === 'return') {
                    await this.loadReturnRoutes();
                    return;
                }
                
                // Otherwise, load outbound routes (default behavior)
                await this.loadOutboundRoutes();
                
            } catch (error) {
                console.error('Failed to load available routes:', error);
                this.showErrorMessage('Failed to load available transfers. Please try again.');
            }
        }
        
        /**
         * Load outbound routes
         */
        async loadOutboundRoutes() {
            try {
                const bookingData = this.manager.bookingData;
                
                // Update title
                this.updateTitle(bookingData);
                
                // Show loading state
                this.showLoadingState();
                
                // Fetch routes from cache system
                const routes = await this.manager.fetchAvailableRoutes(
                    bookingData.from.id,
                    bookingData.to.id,
                    bookingData.outboundDate
                );
                
                // Filter routes based on selected departure time (direction-aware)
                const filteredRoutes = this.filterRoutesByDepartureTime(routes, bookingData.outboundTime, bookingData.from.id, bookingData.to.id);
                
                // Update title with filtered route count
                this.updateTitleWithCount(filteredRoutes.length, bookingData);
                
                // Render routes
                if (filteredRoutes.length > 0) {
                    this.renderRoutes(filteredRoutes);
                } else {
                    this.showNoRoutesMessage();
                }
                
            } catch (error) {
                console.error('Failed to load outbound routes:', error);
                this.showErrorMessage('Failed to load outbound transfers. Please try again.');
            }
        }
        
        /**
         * Update page title with booking data
         * Uses smart templates with numeric placeholders for Weglot
         */
        updateTitle(bookingData) {
            // Outbound selection - the return discount badge/pricing doesn't apply here
            this.hideDiscountBadge();
            
            const fromLabel = bookingData.from?.label || 'Unknown';
            const toLabel = bookingData.to?.label || 'Unknown';
            const date = this.formatDate(bookingData.outboundDate) || 'Unknown date';
            const time = bookingData.outboundTime || '';
            
            // Use smart templates - Weglot sees full sentence context
            const templates = this.titleTemplates || {};
            const template = time ? templates.loading : templates.loadingNoTime;
            
            let titleText = '';
            if (template) {
                if (time) {
                    // Replace {0}=from, {1}=to, {2}=date, {3}=time
                    titleText = template
                        .replace('{0}', fromLabel)
                        .replace('{1}', toLabel)
                        .replace('{2}', date)
                        .replace('{3}', time);
                } else {
                    // Replace {0}=from, {1}=to, {2}=date
                    titleText = template
                        .replace('{0}', fromLabel)
                        .replace('{1}', toLabel)
                        .replace('{2}', date);
                }
            } else {
                // Fallback
                titleText = time ? 
                    `Loading rides from ${fromLabel} to ${toLabel}, ${date}, ${time}` :
                    `Loading rides from ${fromLabel} to ${toLabel}, ${date}`;
            }
            
            this.elements.title.text(titleText);
        }
        
        /**
         * Update title with route count
         * Uses smart templates with numeric placeholders for Weglot
         */
        updateTitleWithCount(count, bookingData) {
            const fromLabel = bookingData.from?.label || 'Unknown';
            const toLabel = bookingData.to?.label || 'Unknown';
            const date = this.formatDate(bookingData.outboundDate) || 'Unknown date';
            const time = bookingData.outboundTime || '';
            
            // Resort -> airport legs offer earlier options; airport -> resort offer later
            const isEarlier = this.isResortToAirportLeg(bookingData.from?.id, bookingData.to?.id);
            
            // Use smart templates - Weglot sees full sentence context
            const templates = this.titleTemplates || {};
            let template;
            if (time) {
                template = isEarlier ? templates.availableEarlier : templates.available;
            } else {
                template = templates.availableNoTime;
            }
            
            let titleText = '';
            if (template) {
                if (time) {
                    // Replace {0}=count, {1}=date, {2}=time
                    titleText = template
                        .replace('{0}', count)
                        .replace('{1}', date)
                        .replace('{2}', time);
                } else {
                    // Replace {0}=count, {1}=date
                    titleText = template
                        .replace('{0}', count)
                        .replace('{1}', date);
                }
            } else {
                // Fallback
                const direction = isEarlier ? 'or earlier' : 'or later';
                titleText = time ? 
                    `${count} rides available on ${date} at ${time} ${direction}` :
                    `${count} rides available on ${date}`;
            }
            
            this.elements.title.text(titleText);
        }
        
        /**
         * Show the return-discount badge next to the step title (return leg only)
         */
        showDiscountBadge() {
            $('#shuttle-step-2-discount-badge').show();
        }
        
        /**
         * Hide the return-discount badge (outbound leg)
         */
        hideDiscountBadge() {
            $('#shuttle-step-2-discount-badge').hide();
        }
        
        /**
         * Show loading state
         */
        showLoadingState() {
            const loadingText = this.titleTemplates?.loadingTransfers || 'Loading available transfers...';
            this.elements.routesContainer.html(`
                <div class="shuttle-step-2__loading">
                    <div class="shuttle-step-2__loading-spinner"></div>
                    <p class="shuttle-step-2__loading-text">${loadingText}</p>
                </div>
            `);
        }
        
        /**
         * Show no routes message
         */
        showNoRoutesMessage() {
            // Hide the title container when showing empty state
            this.elements.titleContainer.hide();
            
            // Get translatable strings
            const templates = this.titleTemplates || {};
            const noBusesTitle = templates.noBusesTitle || 'No buses are available for this date.';
            const noBusesDescription = templates.noBusesDescription || 'Book shared or private transfer and travel comfortably at any time with any luggage.';
            const seeTransferOptions = templates.seeTransferOptions || 'See transfer options';
            const noTransfersAvailable = templates.noTransfersAvailable || 'No transfers available for the selected route and date.';
            const chooseDifferentOptions = templates.chooseDifferentOptions || 'Choose Different Options';
            
            // Replace the entire content area with the empty state
            const contentContainer = $('.shuttle-step-2__content');
            if (contentContainer.length > 0) {
                contentContainer.html(`
                    <div class="shuttle-step-2__empty-state">
                        <div class="shuttle-step-2__empty-container">
                            <img src="${this.getThemeUrl()}/assets/images/shuttle-no-buses-available-74782d.png" 
                                 alt="No buses available" 
                                 class="shuttle-step-2__empty-image">
                            <div class="shuttle-step-2__empty-content">
                                <div class="shuttle-step-2__empty-text">
                                    <h3 class="shuttle-step-2__empty-title">${noBusesTitle}</h3>
                                    <p class="shuttle-step-2__empty-description">${noBusesDescription}</p>
                                </div>
                                <a href="/" class="shuttle-step-2__empty-button">
                                    ${seeTransferOptions}
                                </a>
                            </div>
                        </div>
                    </div>
                `);
            } else {
                // Fallback for routes container only
                this.elements.routesContainer.html(`
                    <div class="shuttle-step-2__no-routes">
                        <p class="shuttle-step-2__no-routes-text">${noTransfersAvailable}</p>
                        <button class="shuttle-step-2__back-btn" onclick="window.shuttleBookingManager.navigateBack()">
                            ${chooseDifferentOptions}
                        </button>
                    </div>
                `);
            }
        }
        
        /**
         * Get theme URL for assets
         */
        getThemeUrl() {
            // Try to get theme URL from WordPress, fallback to relative path
            if (typeof wpData !== 'undefined' && wpData.themeUrl) {
                return wpData.themeUrl;
            }
            // Fallback: construct relative path
            return window.location.origin + '/wp-content/themes/a2a_theme';
        }
        
        /**
         * Show error message
         */
        showErrorMessage(message) {
            this.elements.routesContainer.html(`
                <div class="shuttle-step-2__error">
                    <p class="shuttle-step-2__error-text">${message}</p>
                    <button class="shuttle-step-2__retry-btn" onclick="window.shuttleStep2Handler.loadAvailableRoutes()">
                        Try Again
                    </button>
                </div>
            `);
        }
        
        /**
         * Render route cards
         */
        renderRoutes(routes) {
            try {
                // Ensure the title container is visible when showing routes
                this.elements.titleContainer.show();
                
                // Store routes for selection handling
                this.availableRoutes = routes;
                
                const routeCards = routes.map(route => this.createRouteCard(route)).join('');
                this.elements.routesContainer.html(routeCards);
                
                // Set up route card event listeners
                this.setupRouteCardListeners();
                
                // Track GA UA Enhanced Ecommerce: Product Detail View (STEP 2)
                if (window.ShuttleGAEvents) {
                    const gaEvents = new window.ShuttleGAEvents();
                    gaEvents.trackProductDetail(this.manager.bookingData, routes);
                }
                
            } catch (error) {
                console.error('Failed to render routes:', error);
                this.showErrorMessage('Failed to display routes. Please try again.');
            }
        }
        
        /**
         * Create HTML for a single route card
         */
        createRouteCard(route) {
            // Get passenger count for total price calculation
            const bookingData = this.manager.bookingData;
            const totalPassengers = (bookingData.passengers?.adults || 1) + (bookingData.passengers?.children || 0);
            
            // Return-leg cards get the admin-configured return discount applied to
            // the displayed price (the checkout page computes and validates the
            // authoritative discount against the real, tier-inclusive price)
            const returnDiscountRate = this.manager.getReturnDiscountRate();
            const isReturnLeg = bookingData.currentSelection === 'return' && returnDiscountRate > 0;
            const RETURN_DISCOUNT_MULTIPLIER = 1 - returnDiscountRate;
            
            // Use pre-converted price and calculate total for all passengers
            let priceFormatted = '€0.00';
            let originalPriceFormatted = '';
            let tooltipText = 'Price information';
            try {
                // Route already has converted price from currency manager
                const amount = route.price?.amount || 0;
                const numericAmount = typeof amount === 'number' ? amount : parseFloat(amount) || 0;
                
                // Calculate total price (price per person × number of passengers)
                const totalPrice = numericAmount * totalPassengers;
                const displayPrice = isReturnLeg ? totalPrice * RETURN_DISCOUNT_MULTIPLIER : totalPrice;
                
                // Use currency manager to format the displayed (discounted) total price
                priceFormatted = this.manager.currencyManager.formatPrice(displayPrice);
                
                if (isReturnLeg) {
                    originalPriceFormatted = this.manager.currencyManager.formatPrice(totalPrice);
                }
                
                // Create tooltip text using smart template
                const templates = this.titleTemplates || {};
                const templateKey = totalPassengers !== 1 ? 'totalPriceForPlural' : 'totalPriceForSingular';
                const template = templates[templateKey];
                
                if (template) {
                    // Replace {0} with passenger count
                    tooltipText = template.replace('{0}', totalPassengers);
                } else {
                    // Fallback
                    const passengerWord = totalPassengers !== 1 ? 'passengers' : 'passenger';
                    tooltipText = `Total price for ${totalPassengers} ${passengerWord}`;
                }
            } catch (error) {
                console.warn('Failed to format price:', route.price, error);
                // Fallback formatting
                const amount = route.price?.amount || 0;
                const totalPrice = amount * totalPassengers;
                const displayPrice = isReturnLeg ? totalPrice * RETURN_DISCOUNT_MULTIPLIER : totalPrice;
                const currency = route.price?.currency || 'EUR';
                const currencySymbol = this.getCurrencySymbol(currency);
                priceFormatted = `${currencySymbol}${displayPrice.toFixed(2)}`;
                if (isReturnLeg) {
                    originalPriceFormatted = `${currencySymbol}${totalPrice.toFixed(2)}`;
                }
            }
            
            // Safely get route data with fallbacks
            const routeId = route.id || 'unknown';
            const departureTime = route.departureTime || 'N/A';
            const arrivalTime = route.arrivalTime || 'N/A';
            const duration = route.duration || '~1h 30m';
            const fromLocation = route.fromLocation || 'Unknown';
            const toLocation = route.toLocation || 'Unknown';
            
            // Get translatable strings
            const templates = this.titleTemplates || {};
            const totalPriceLabel = templates.totalPrice || 'Total price';
            const bookButtonText = templates.book || 'Book';
            
            return `
                <div class="shuttle-route-card" data-route-id="${routeId}">
                    <!-- Timeline Section -->
                    <div class="shuttle-route-card__timeline">
                        <!-- Departure Point -->
                        <div class="shuttle-route-card__point shuttle-route-card__point--departure">
                            <div class="shuttle-route-card__time">${departureTime}</div>
                            <div class="shuttle-route-card__location">${fromLocation}</div>
                        </div>
                        
                        <!-- Journey Line -->
                        <div class="shuttle-route-card__journey">
                            <div class="shuttle-route-card__line-start"></div>
                            <div class="shuttle-route-card__duration">${duration}</div>
                            <div class="shuttle-route-card__line-end"></div>
                        </div>
                        
                        <!-- Arrival Point -->
                        <div class="shuttle-route-card__point shuttle-route-card__point--arrival">
                            <div class="shuttle-route-card__time">${arrivalTime}</div>
                            <div class="shuttle-route-card__location">${toLocation}</div>
                        </div>
                    </div>
                    
                    <!-- Price Section -->
                    <div class="shuttle-route-card__price">
                        ${isReturnLeg ? `<span class="shuttle-route-card__price-original">${originalPriceFormatted}</span>` : ''}
                        <div class="shuttle-route-card__price-row">
                            <span class="shuttle-route-card__price-amount">${priceFormatted}</span>
                            <button class="shuttle-route-card__price-info" type="button" title="${tooltipText}">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" fill="#C2D6E7"/>
                                </svg>
                            </button>
                        </div>
                        <span class="shuttle-route-card__price-label">${totalPriceLabel}</span>
                    </div>
                    
                    <!-- Book Button -->
                    <button class="shuttle-route-card__book-btn" data-route-id="${routeId}">
                        ${bookButtonText}
                    </button>
                </div>
            `;
        }
        
        /**
         * Set up event listeners for route cards
         */
        setupRouteCardListeners() {
            // Book button clicks
            $('.shuttle-route-card__book-btn').off('click').on('click', (e) => {
                const routeId = $(e.target).data('route-id');
                this.handleRouteSelection(routeId);
            });
            
            // Price info button hover - show custom tooltip (desktop only)
            $('.shuttle-route-card__price-info').off('mouseenter mouseleave').on({
                mouseenter: (e) => {
                    // Only show on hover for non-touch devices
                    if (!('ontouchstart' in window)) {
                        this.showCustomTooltip(e.target);
                    }
                },
                mouseleave: (e) => {
                    // Only hide on mouse leave for non-touch devices
                    if (!('ontouchstart' in window)) {
                        this.hideCustomTooltip();
                    }
                }
            });
            
            // Price info button clicks - show tooltip (mobile and desktop)
            $('.shuttle-route-card__price-info').off('click touchstart').on('click touchstart', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                // For touch devices, always toggle
                if ('ontouchstart' in window) {
                    this.toggleCustomTooltip(e.currentTarget);
                } else {
                    // For desktop, also allow click to toggle
                    this.toggleCustomTooltip(e.currentTarget);
                }
            });
        }
        
        /**
         * Determine what type of route selection we're currently handling
         */
        getCurrentSelectionType() {
            const bookingData = this.manager.bookingData;
            
            // For one-way trips, always outbound
            if (bookingData.transferType === 'one-way') {
                return 'outbound';
            }
            
            // For return trips, check what we need to select
            if (bookingData.transferType === 'return') {
                // If we don't have outbound selection, we need outbound
                if (!bookingData.selectedRoutes?.outbound) {
                    return 'outbound';
                }
                // If we have outbound but no return, we need return
                if (!bookingData.selectedRoutes?.return) {
                    return 'return';
                }
                // If we have both, check the current selection state
                return bookingData.currentSelection || 'completed';
            }
            
            return 'outbound'; // Default fallback
        }
        
        /**
         * Handle route selection
         */
        handleRouteSelection(routeId) {
            try {
                
                // Find the selected route data
                const selectedRoute = this.availableRoutes.find(route => route.id === routeId);
                if (!selectedRoute) {
                    throw new Error('Selected route not found in available routes');
                }
                
                // Determine route type based on current booking state
                let routeType = this.getCurrentSelectionType();
                
                // Safety check: if we're in completed state but user is selecting a route,
                // we need to determine which route they're actually changing
                if (routeType === 'completed') {
                    // Check which routes are currently displayed to determine selection type
                    const bookingData = this.manager.bookingData;
                    if (bookingData.currentSelection === 'return') {
                        routeType = 'return';
                    } else {
                        // Default to outbound if we can't determine
                        routeType = 'outbound';
                    }
                }
                
                // Save route selection using booking manager
                const success = this.manager.saveSelectedRoute(selectedRoute, routeType);
                if (!success) {
                    throw new Error('Failed to save route selection');
                }
                
                // Track GA event: book_outbound or book_return (Rows 7 & 8)
                if (window.ShuttleGAEvents) {
                    const gaEvents = new window.ShuttleGAEvents();
                    const departureTime = selectedRoute.departureTime || '';
                    
                    if (routeType === 'outbound') {
                        gaEvents.trackBookOutbound(departureTime);
                    } else if (routeType === 'return') {
                        gaEvents.trackBookReturn(departureTime);
                    }
                }
                
                // Update UI feedback
                $('.shuttle-route-card').removeClass('shuttle-route-card--selected');
                $(`.shuttle-route-card[data-route-id="${routeId}"]`).addClass('shuttle-route-card--selected');
                
                // Handle navigation based on transfer type and current selection
                this.handlePostSelectionNavigation(routeType);
                
            } catch (error) {
                console.error('Failed to handle route selection:', error);
            }
        }
        
        /**
         * Handle navigation after route selection
         */
        handlePostSelectionNavigation(routeType) {
            // Get fresh booking data after the route was saved
            const { transferType, currentSelection } = this.manager.bookingData;
            
            
            if (transferType === 'one-way') {
                // One-way trip - always go to checkout after outbound selection
                this.proceedToCheckout();
            } else if (transferType === 'return') {
                if (currentSelection === 'return') {
                    // Return trip - outbound selected, need to select return route
                    // Scroll to top on mobile before loading return routes
                    this.scrollToTopOnMobile();
                    this.loadReturnRoutes();
                } else if (currentSelection === 'completed') {
                    // Return trip - both routes selected, go to checkout
                    this.proceedToCheckout();
                } else {
                    console.warn('Unexpected return trip state:', { currentSelection, routeType });
                }
            } else {
                console.warn('Unexpected navigation state:', { transferType, currentSelection, routeType });
            }
        }
        
        /**
         * Proceed to checkout (Step 3)
         */
        proceedToCheckout() {
            try {
                // Validate that we have all required selections
                if (!this.manager.isReadyForCheckout()) {
                    throw new Error('Not ready for checkout - missing route selections');
                }
                
                // Update step and navigate
                this.manager.updateBookingData({ step: 3 });
                
                // Navigate to checkout page using dynamic URL with language support
                const checkoutUrl = window.shuttleCheckoutUrl || '/shared-economy-booking/shared-economy-checkout/';
                window.location.href = this.manager.buildLanguageAwareUrl(checkoutUrl);
                
            } catch (error) {
                this.showError('Failed to proceed to checkout. Please try again.');
            }
        }
        
        /**
         * Load return routes (for return trips)
         */
        async loadReturnRoutes() {
            try {
                
                // Update booking data to reflect return selection state
                this.manager.updateBookingData({ currentSelection: 'return' });
                
                // Update progress breadcrumbs to show return step
                this.updateProgress();
                
                // Update title and UI for return selection
                this.updateTitleForReturn();
                
                // Show loading state
                this.showLoadingState();
                
                // Start loading timer for minimum 500ms loading time
                const loadingStartTime = Date.now();
                const minLoadingTime = 500; // 0.5 seconds
                
                // Fetch return routes (reverse direction)
                const bookingData = this.manager.bookingData;
                const returnRoutes = await this.manager.fetchAvailableRoutes(
                    bookingData.to.id,    // Reverse: to becomes from
                    bookingData.from.id,  // Reverse: from becomes to
                    bookingData.returnDate
                );
                
                
                // Filter routes based on selected return time (direction-aware; reversed leg)
                const filteredRoutes = this.filterRoutesByDepartureTime(returnRoutes, bookingData.returnTime, bookingData.to.id, bookingData.from.id);
                
                
                // Calculate remaining loading time to ensure minimum delay
                const loadingElapsed = Date.now() - loadingStartTime;
                const remainingTime = Math.max(0, minLoadingTime - loadingElapsed);
                
                // Wait for remaining time if needed
                if (remainingTime > 0) {
                    await new Promise(resolve => setTimeout(resolve, remainingTime));
                }
                
                // Update title with route count
                this.updateTitleWithCountForReturn(filteredRoutes.length, bookingData);
                
                // Render return routes
                if (filteredRoutes.length > 0) {
                    this.renderRoutes(filteredRoutes);
                } else {
                    this.showNoRoutesMessage();
                }
                
            } catch (error) {
                console.error('Failed to load return routes:', error);
                this.showErrorMessage('Failed to load return routes. Please try again.');
            }
        }
        
        /**
         * Update title for return route selection
         * Uses smart templates with numeric placeholders for Weglot
         */
        updateTitleForReturn() {
            // Return selection - prices shown include the return discount
            this.showDiscountBadge();
            
            const bookingData = this.manager.bookingData;
            const fromLabel = bookingData.to?.label || 'Unknown';  // Reverse direction
            const toLabel = bookingData.from?.label || 'Unknown';  // Reverse direction
            const date = this.formatDate(bookingData.returnDate) || 'Unknown date';
            const time = bookingData.returnTime || '';
            
            // Use smart templates - Weglot sees full sentence context
            const templates = this.titleTemplates || {};
            const template = time ? templates.loadingReturn : templates.loadingReturnNoTime;
            
            let titleText = '';
            if (template) {
                if (time) {
                    // Replace {0}=from, {1}=to, {2}=date, {3}=time
                    titleText = template
                        .replace('{0}', fromLabel)
                        .replace('{1}', toLabel)
                        .replace('{2}', date)
                        .replace('{3}', time);
                } else {
                    // Replace {0}=from, {1}=to, {2}=date
                    titleText = template
                        .replace('{0}', fromLabel)
                        .replace('{1}', toLabel)
                        .replace('{2}', date);
                }
            } else {
                // Fallback
                titleText = time ? 
                    `Loading return rides from ${fromLabel} to ${toLabel}, ${date}, ${time}` :
                    `Loading return rides from ${fromLabel} to ${toLabel}, ${date}`;
            }
            
            this.elements.title.text(titleText);
        }
        
        /**
         * Update title with route count for return selection
         * Uses smart templates with numeric placeholders for Weglot
         */
        updateTitleWithCountForReturn(count, bookingData) {
            const fromLabel = bookingData.to?.label || 'Unknown';  // Reverse direction
            const toLabel = bookingData.from?.label || 'Unknown';  // Reverse direction
            const date = this.formatDate(bookingData.returnDate) || 'Unknown date';
            const time = bookingData.returnTime || '';
            
            // Return leg is reversed (to -> from); resort -> airport offers earlier options
            const isEarlier = this.isResortToAirportLeg(bookingData.to?.id, bookingData.from?.id);
            
            // Use smart templates - Weglot sees full sentence context
            const templates = this.titleTemplates || {};
            let template;
            if (time) {
                template = isEarlier ? templates.returnAvailableEarlier : templates.returnAvailable;
            } else {
                template = templates.returnAvailableNoTime;
            }
            
            let titleText = '';
            if (template) {
                if (time) {
                    // Replace {0}=count, {1}=date, {2}=time
                    titleText = template
                        .replace('{0}', count)
                        .replace('{1}', date)
                        .replace('{2}', time);
                } else {
                    // Replace {0}=count, {1}=date
                    titleText = template
                        .replace('{0}', count)
                        .replace('{1}', date);
                }
            } else {
                // Fallback
                const direction = isEarlier ? 'or earlier' : 'or later';
                titleText = time ? 
                    `${count} return rides available on ${date} at ${time} ${direction}` :
                    `${count} return rides available on ${date}`;
            }
            
            this.elements.title.text(titleText);
        }
        
        /**
         * Get currency symbol for a given currency code
         */
        getCurrencySymbol(currency) {
            const currencySymbols = {
                'EUR': '€',
                'GBP': '£',
                'USD': '$',
                'CHF': 'CHF ',
                'PLN': 'zł',
                'CZK': 'Kč'
            };
            
            return currencySymbols[currency] || currency + ' ';
        }
        
        /**
         * Determine if a leg is resort -> airport based on the fetch IDs
         */
        isResortToAirportLeg(fromId, toId) {
            return String(fromId || '').startsWith('resort-') && String(toId || '').startsWith('airport-');
        }
        
        /**
         * Select the rides to offer around the requested time (direction-aware).
         * - Airport -> resort: closest departure at/after requested + up to 2 later (max 3)
         * - Resort -> airport: closest departure at/before requested + up to 2 earlier (max 3),
         *   so return-to-airport transfers never offer times later than requested.
         */
        filterRoutesByDepartureTime(routes, selectedTime, fromId, toId) {
            if (!selectedTime || !Array.isArray(routes)) {
                return routes;
            }
            
            try {
                // Convert selected time to minutes for comparison
                const selectedMinutes = this.timeToMinutes(selectedTime);
                
                // Defensive ascending sort (cache is already sorted)
                const sorted = [...routes]
                    .filter(r => r && r.departureTime)
                    .sort((a, b) => this.timeToMinutes(a.departureTime) - this.timeToMinutes(b.departureTime));
                
                if (this.isResortToAirportLeg(fromId, toId)) {
                    // Resort -> airport: closest at/before requested + up to 2 earlier
                    const candidates = sorted.filter(r => this.timeToMinutes(r.departureTime) <= selectedMinutes);
                    return candidates.slice(-3);
                }
                
                // Airport -> resort (and any other combo): closest at/after requested + up to 2 later
                const candidates = sorted.filter(r => this.timeToMinutes(r.departureTime) >= selectedMinutes);
                return candidates.slice(0, 3);
                
            } catch (error) {
                console.error('Failed to filter routes by departure time:', error);
                return routes; // Return all routes if filtering fails
            }
        }
        
        /**
         * Convert time string (HH:MM) to minutes since midnight
         */
        timeToMinutes(timeStr) {
            if (!timeStr || typeof timeStr !== 'string') {
                return 0;
            }
            
            const parts = timeStr.split(':');
            if (parts.length !== 2) {
                return 0;
            }
            
            const hours = parseInt(parts[0], 10);
            const minutes = parseInt(parts[1], 10);
            
            if (isNaN(hours) || isNaN(minutes)) {
                return 0;
            }
            
            return hours * 60 + minutes;
        }
        
        /**
         * Format date for display (keep DD.MM.YY format)
         */
        formatDate(dateStr) {
            if (!dateStr) return '';
            
            try {
                // Handle the format "25.09.25, 09:15" from the booking data
                if (dateStr.includes(',')) {
                    const datePart = dateStr.split(',')[0].trim(); // "25.09.25"
                    return datePart; // Return as-is in DD.MM.YY format
                }
                
                // If it's already in DD.MM.YY format, return as-is
                if (dateStr.match(/^\d{2}\.\d{2}\.\d{2}$/)) {
                    return dateStr;
                }
                
                // Fallback: try to convert other date formats to DD.MM.YY
                const date = new Date(dateStr);
                
                if (!isNaN(date.getTime())) {
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = String(date.getFullYear()).slice(-2); // Get last 2 digits
                    
                    return `${day}.${month}.${year}`;
                }
                
                // If all else fails, return original string
                console.warn('Could not format date:', dateStr);
                return dateStr;
                
            } catch (error) {
                console.error('Date formatting error:', error, 'for date:', dateStr);
                return dateStr;
            }
        }
        
        /**
         * Show error message
         */
        showError(message) {
            this.elements.routesContainer.html(`
                <div class="shuttle-step-2__error">
                    <div style="padding: 48px 24px; text-align: center; background: #FFF5F5; border: 1px solid #FEB2B2; border-radius: 12px;">
                        <p style="color: #C53030; margin: 0;">${message}</p>
                    </div>
                </div>
            `);
        }
        
        /**
         * Show custom tooltip on hover
         */
        showCustomTooltip(target) {
            const tooltipText = $(target).attr('title');
            if (!tooltipText) return;
            
            // Remove existing tooltip
            this.hideCustomTooltip();
            
            // Check if we're on mobile
            const isMobile = window.innerWidth <= 768;
            
            // Create tooltip element
            const tooltip = $(`
                <div class="shuttle-custom-tooltip" style="
                    position: absolute;
                    background: #2D3748;
                    color: white;
                    padding: 8px 12px;
                    border-radius: 6px;
                    font-size: 12px;
                    z-index: 1000;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    pointer-events: none;
                    ${isMobile ? 'white-space: normal; max-width: 200px;' : 'white-space: nowrap;'}
                ">${tooltipText}</div>
            `);
            
            const $target = $(target);
            
            if (isMobile) {
                // Mobile: Position relative to the price info button itself
                const $target = $(target);
                
                // Make the button container relative
                $target.css('position', 'relative');
                
                // Add tooltip to the button (relative positioning)
                $target.append(tooltip);
                
                // Simple positioning: right-aligned with card padding, above the button
                tooltip.css({
                    position: 'absolute',
                    right: '16px', // Align with card padding
                    bottom: '38px', // Fixed position as requested
                    left: 'auto' // Reset any left positioning
                });
                
            } else {
                // Desktop: Position relative to viewport (existing logic)
                const targetOffset = $target.offset();
                const targetWidth = $target.outerWidth();
                const targetHeight = $target.outerHeight();
                
                // Add to body
                $('body').append(tooltip);
                
                // Calculate position (above the button)
                const tooltipWidth = tooltip.outerWidth();
                const tooltipHeight = tooltip.outerHeight();
                
                let left = targetOffset.left + (targetWidth / 2) - (tooltipWidth / 2);
                const top = targetOffset.top - tooltipHeight - 8;
                
                // Keep tooltip within viewport
                const viewportWidth = $(window).width();
                if (left + tooltipWidth > viewportWidth - 10) {
                    left = viewportWidth - tooltipWidth - 10;
                }
                if (left < 10) {
                    left = 10;
                }
                
                tooltip.css({
                    left: left + 'px',
                    top: top + 'px'
                });
            }
        }
        
        /**
         * Hide custom tooltip
         */
        hideCustomTooltip() {
            $('.shuttle-custom-tooltip').remove();
            // Reset any button positioning that was set for mobile tooltips
            $('.shuttle-route-card__price-info').css('position', '');
            // Clean up event listeners
            $(document).off('click.tooltip touchstart.tooltip');
        }
        
        /**
         * Toggle custom tooltip (for mobile clicks)
         */
        toggleCustomTooltip(target) {
            if ($('.shuttle-custom-tooltip').length > 0) {
                this.hideCustomTooltip();
            } else {
                this.showCustomTooltip(target);
                
                // For touch devices, add click-outside handler and auto-hide
                if ('ontouchstart' in window) {
                    // Small delay to prevent immediate hiding from the same tap
                    setTimeout(() => {
                        // Hide when clicking outside
                        $(document).off('click.tooltip touchstart.tooltip').on('click.tooltip touchstart.tooltip', (e) => {
                            if (!$(e.target).closest('.shuttle-route-card__price-info, .shuttle-custom-tooltip').length) {
                                this.hideCustomTooltip();
                                $(document).off('click.tooltip touchstart.tooltip');
                            }
                        });
                    }, 100);
                    
                    // // Auto-hide after 5 seconds on mobile
                    // setTimeout(() => {
                    //     this.hideCustomTooltip();
                    //     $(document).off('click.tooltip touchstart.tooltip');
                    // }, 5000);
                }
            }
        }
        
        /**
         * Show currency conversion loading state
         */
        showCurrencyConversionLoading() {
            $('.shuttle-route-card__price-amount').addClass('converting');
        }
        
        /**
         * Hide currency conversion loading state
         */
        hideCurrencyConversionLoading() {
            $('.shuttle-route-card__price-amount').removeClass('converting');
        }
        
        /**
         * Reload routes with new currency conversion
         */
        async reloadRoutesWithNewCurrency() {
            try {
                
                // Show currency conversion loading state first
                this.showCurrencyConversionLoading();
                
                // Brief delay to show loading state
                await new Promise(resolve => setTimeout(resolve, 200));
                
                // Show main loading state
                this.showLoadingState();
                
                // Get current booking data
                const bookingData = this.manager.bookingData;
                
                // Determine which routes to reload based on current selection
                if (bookingData.currentSelection === 'return') {
                    // Reload return routes
                    const returnRoutes = await this.manager.fetchAvailableRoutes(
                        bookingData.to.id,    // Reverse: to becomes from
                        bookingData.from.id,  // Reverse: from becomes to
                        bookingData.returnDate
                    );
                    
                    // Filter routes based on selected return time (direction-aware; reversed leg)
                    const filteredRoutes = this.filterRoutesByDepartureTime(returnRoutes, bookingData.returnTime, bookingData.to.id, bookingData.from.id);
                    
                    // Update title with route count
                    this.updateTitleWithCountForReturn(filteredRoutes.length, bookingData);
                    
                    // Render return routes
                    if (filteredRoutes.length > 0) {
                        this.renderRoutes(filteredRoutes);
                    } else {
                        this.showNoRoutesMessage();
                    }
                } else {
                    // Reload outbound routes
                    const routes = await this.manager.fetchAvailableRoutes(
                        bookingData.from.id,
                        bookingData.to.id,
                        bookingData.outboundDate
                    );
                    
                    // Filter routes based on selected departure time (direction-aware)
                    const filteredRoutes = this.filterRoutesByDepartureTime(routes, bookingData.outboundTime, bookingData.from.id, bookingData.to.id);
                    
                    // Update title with filtered route count
                    this.updateTitleWithCount(filteredRoutes.length, bookingData);
                    
                    // Render routes
                    if (filteredRoutes.length > 0) {
                        this.renderRoutes(filteredRoutes);
                    } else {
                        this.showNoRoutesMessage();
                    }
                }
                
                // Update stored route selections with new currency
                this.updateStoredRouteSelections();
                
                
            } catch (error) {
                console.error('Failed to reload routes with new currency:', error);
                this.showErrorMessage('Failed to update prices. Please refresh the page.');
            }
        }
        
        /**
         * Update stored route selections with new currency conversion
         */
        updateStoredRouteSelections() {
            try {
                const bookingData = this.manager.bookingData;
                let updated = false;
                
                // Update outbound route selection if it exists
                if (bookingData.selectedRoutes?.outbound) {
                    const outboundRoute = bookingData.selectedRoutes.outbound;
                    if (outboundRoute.price?.original) {
                        // Convert original price to new currency
                        const originalAmount = outboundRoute.price.original.amount;
                        const originalCurrency = outboundRoute.price.original.currency;
                        const convertedAmount = this.manager.currencyManager.convertPrice(originalAmount, originalCurrency);
                        const formattedPrice = this.manager.currencyManager.formatPrice(convertedAmount);
                        
                        // Update the stored route selection
                        bookingData.selectedRoutes.outbound.price = {
                            amount: convertedAmount,
                            currency: this.manager.currencyManager.currentCurrency,
                            formatted: formattedPrice,
                            original: outboundRoute.price.original // Keep original for future conversions
                        };
                        
                        updated = true;
                    }
                }
                
                // Update return route selection if it exists
                if (bookingData.selectedRoutes?.return) {
                    const returnRoute = bookingData.selectedRoutes.return;
                    if (returnRoute.price?.original) {
                        // Convert original price to new currency
                        const originalAmount = returnRoute.price.original.amount;
                        const originalCurrency = returnRoute.price.original.currency;
                        const convertedAmount = this.manager.currencyManager.convertPrice(originalAmount, originalCurrency);
                        const formattedPrice = this.manager.currencyManager.formatPrice(convertedAmount);
                        
                        // Update the stored route selection
                        bookingData.selectedRoutes.return.price = {
                            amount: convertedAmount,
                            currency: this.manager.currencyManager.currentCurrency,
                            formatted: formattedPrice,
                            original: returnRoute.price.original // Keep original for future conversions
                        };
                        
                        updated = true;
                    }
                }
                
                // Save updated booking data to localStorage if any changes were made
                if (updated) {
                    this.manager.saveBookingData();
                }
                
            } catch (error) {
                console.error('Failed to update stored route selections:', error);
            }
        }
    }
    
    // Initialize when DOM is ready
    if ($('#shuttle-booking-app[data-step="2"]').length > 0) {
        window.shuttleStep2Handler = new ShuttleStep2Handler();
    }
});
